/**
 * テーマ（FR-THEME）。見た目は CSS カスタムプロパティで表現する。
 * 配色プリセットは data 属性で選び（実値は assets/theme.css）、
 * 個別の上書きはルート要素のインラインカスタムプロパティとして適用する。
 */
import { attr, cssVar } from '../brand';
import type { ThemeOptions, ThemePreset } from '../core/options';

const PRESET_ATTR = attr('theme');

/** テーマを適用し、解除関数を返す（theme のキーは接頭辞を除いた名前）。 */
export function applyTheme(
  root: HTMLElement,
  preset: ThemePreset,
  theme: ThemeOptions,
): () => void {
  root.setAttribute(PRESET_ATTR, preset);

  const applied: string[] = [];
  for (const [key, value] of Object.entries(theme)) {
    const name = cssVar(key);
    root.style.setProperty(name, value);
    applied.push(name);
  }

  return () => {
    root.removeAttribute(PRESET_ATTR);
    for (const name of applied) root.style.removeProperty(name);
  };
}
